import React from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';

import TheHeader from '@components/TheHeader';
import Footer from '@components/Footer/Footer';

import { header } from '@utils/default-values';
import useShareModal from '@utils/hooks/use-share-modal';
import { selectorSession } from '@model/session';
import { LoaderFullPage } from '@app/loaders/LoaderFullPage';
import { CompensationVisibilityModal } from '@components/_modals/CompensationVisibilityModal/index';

const SecondaryLayout = ({ children, customClasses = '' }) => {
  const headerLabels = header();
  const initialized = useStoreState(state => state.initialized);
  const { loading } = useStoreState(selectorSession);
  const isModalOpened = useStoreState(state => state.isModalOpened);
  const modalId = useStoreState(state => state.modalId);
  const setModalOpened = useStoreActions(actions => actions.setModalOpened);
  const setModalId = useStoreActions(actions => actions.setModalId);

  const { handleShareButtonClick } = useShareModal();

  if (!initialized || loading) {
    return <LoaderFullPage />;
  }

  return (
    <main data-testid="secondary-layout">
      <div className="rev-o-container">
        <div className="rev-o-grid">
          <div className="rev-o-col-12 rev-u-px-16 rev-u-py-16">
            <TheHeader labels={headerLabels} onClick={handleShareButtonClick} />
          </div>
        </div>
      </div>
      <div className={`c-secondary-layout ${customClasses}`}>{children}</div>
      <Footer
        logo={
          __ENVIRONMENT_CONFIG__.IS_THEME_AKI
            ? `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/aaron-king-logo.png`
            : undefined
        }
        payoff={
          __ENVIRONMENT_CONFIG__.IS_THEME_AKI
            ? `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/aki-payoff.svg`
            : undefined
        }
      />
      <CompensationVisibilityModal
        isOpen={isModalOpened}
        modalId={modalId}
        onClose={() => {
          setModalOpened(false);
          setModalId(null);
        }}
      />
    </main>
  );
};

export default SecondaryLayout;
